import { render } from "./Loader.vue?vue&type=template&id=c14367b0"
const script = {}
script.render = render

export default script